import axios from 'axios';

const BASEURL = process.env.BASE_URL;

// GET OSH Countries for the Selectors
export function getOSHCountries(dataPage, countries) {
    const URL = `${BASEURL}countries/getCountriesMatrixPage`;

    const response = axios.get(URL, {
        params: {
            page: dataPage,
            country: countries
        },
        paramsSerializer: params => {
            let urlWithParams = new URLSearchParams()

            if(params.page) {
                urlWithParams.append('page', params.page);
            }

            if (params.country) {
                params.country.map((country) => urlWithParams.append('country', country));
            }

            return urlWithParams
        }
    })
    .then((res) => res.data);

    return response
}

// Get Organisations for International Programmes
export function getOrganisations() {
    const URL = `${BASEURL}qualitative/getOrganisations`;

    const response = axios.get(URL)
    .then((response) => response.data);

    return response
}

// GET OSH data for components OSH-Authorities, OSH-Statistics
export function getOSHData(dataPage, filters) {
    const URL = `${BASEURL}qualitative/getMatrixPageData`;

    const response = axios.get(URL, {
        params: {
            page: dataPage,
            country: filters?.countries,
            organisation: filters?.organisations,
            checks: filters?.checks,
            searchBar: filters?.searchBar
        },
        paramsSerializer: params => {
            let urlWithParams = new URLSearchParams();

            if (params.page) {
                urlWithParams.append('page', params.page)
            }

            if (params.country) {
                params.country.map((country) => urlWithParams.append('country', country.code));
            }           

            if (params.organisation) {
                params.organisation.map((organisation) => urlWithParams.append('organisation', organisation.id));
            }

            if (params.checks) {
                params.checks.map((check) => urlWithParams.append(`check${check.id}`, check.check))
            }

            if (params.searchBar) {
                urlWithParams.append('search', params.searchBar)
            }

            return urlWithParams
        }
    })
    .then((response) => response.data);

    return response
}

// get data for the charts
export function getChartData(filter) {
    const URL = `${BASEURL}quantitative/getChartData`

    let sort = undefined;

    if (filter.sortAnswer == 'value')
    {
        sort = 'value';
    }
    else if (filter.sortAnswer != undefined)
    {
        sort = 'answer';
    }

    const response = axios.get(URL, {
        params: {
            chart: filter.chart,
            indicator: filter.indicator,
            country1: filter.country1,
            country2: filter.country2,
            country3: filter.country3,
            sector: filter.sector,
            answers: filter.answers,
            size: filter.size,
            dataset: filter.dataset,
            sort,
            sortAnswer: filter.sortAnswer
        },
        paramsSerializer: params => {
            let urlWithParams = new URLSearchParams();

            if (params.chart) {
                urlWithParams.append('chart', params.chart);
            }

            if (params.indicator) {
                urlWithParams.append('indicator', params.indicator);
            }

            if (params.country1) {
                urlWithParams.append('country1', params.country1);
            }

            if (params.country2) {
                urlWithParams.append('country2', params.country2);
            }

            if (params.country3) {
                urlWithParams.append('country3', params.country3);
            }

            if (params.sector) {
                params.sector.map((sector) => urlWithParams.append('sector', sector)); 
            }

            if (params.answers) {
                params.answers.map((answer) => urlWithParams.append('answer', answer));
            }

            if (params.size) {
                params.size.map((size) => urlWithParams.append('size', size));
            }

            if(params.dataset){
                urlWithParams.append('dataset', params.dataset);
            }

            if(params.sort){
                urlWithParams.append('sort', params.sort);
            }

            if (params.sortAnswer) {
                params.sortAnswer.map((sortAnswer) => urlWithParams.append('sortAnswer', sortAnswer));
            }

            return urlWithParams
        }
        
    }).then((res) => {
        return res.data
    })

    return response;
}

export function getIndicatorCountries(charts = ['20012'], indicator, country, country2, countryReport) {
    const URL = `${BASEURL}countries/getIndicatorCountries`

    const response = axios.get(URL, {
        params: {
            charts,
            indicator,
            country,
            country2,
            countryReport
        },
        paramsSerializer: params => {
            let urlWithParams = new URLSearchParams();

            if (params.charts) {
                params.charts.map((chart) => urlWithParams.append('chart', chart));
            }

            if (params.indicator) {
                urlWithParams.append('indicator', params.indicator);
            }

            if (params.country) {
                urlWithParams.append('country', params.country);
            }

            if (params.country2) {
                urlWithParams.append('country', params.country2);
            }

            if (params.countryReport) {
                urlWithParams.append('report', params.countryReport);
            }

            return urlWithParams
        }
    })
        .then((response) => {
            return response.data
            
        });
        
    return response
}

// get the Activity Sectors for the Select filter
export function getActivitySectors(indicator)
{
    const URL = `${BASEURL}filters/getChartActivitySectors`

    const response = axios.get(URL, {
        params: {
            indicator
        },
        paramsSerializer: params => {
            let urlWithParams = new URLSearchParams();

            if (params.indicator) {
                urlWithParams.append('indicator', params.indicator);
            }

            return urlWithParams
        }
    })
        .then((response) => {
            return response.data
            
        });
        
    return response
}

//Get countries available for social dialogue select
export function getNationalStrategiesCountries(country, country2) {
    const URL = `${BASEURL}countries/getCountriesStrategiesPage?page=STRATEGY`;

    const response = axios.get(URL, {
        params: {
            country: country,
            country2: country2
        },
        paramsSerializer: params => {
            let urlWithParams = new URLSearchParams();

            if (params.country) {
                urlWithParams.append('country', country);
            }

            if (params.country2) {
                urlWithParams.append('country', country2);
            }

            return urlWithParams
        }
    })
    .then((response) => {
        return response.data        
    });

    return response
}

// Get the data for the National Strategies - Country Profile page
export function getCountryProfileData(country){
    const URL = `${BASEURL}qualitative/getMatrixPageData?page=STRATEGY`

    const response = axios.get(URL, {
        params: {
            country: country
        },
        paramsSerializer: params => {
            let urlWithParams = new URLSearchParams();

            if (params.country) {
                urlWithParams.append('country', country);
            }

            return urlWithParams
        }
    })
    .then((response) => response.data);

    return response
}

//Get countries available for social dialogue select
export function getSocialDialogueCountries() {
    const URL = `${BASEURL}countries/getIndicatorCountries?chart=20090`;

    const response = axios.get(URL)
    .then((res) => res.data);

    return response
}

//Get social dialogue data for each available country including EU27
export function getSocialDialogueData(filters){
    const URL = `${BASEURL}quantitative/getCountryCardData?chart=20090`;
    const response = axios.get(URL, {
        params: {
            country: filters?.countries,
            dataset: filters?.dataset
        },
        paramsSerializer: params => {
            let urlWithParams = new URLSearchParams();

            if (params.country) {
                params.country.map((country) => urlWithParams.append('country', country.code));
            }

            if (params.dataset) 
            {
                urlWithParams.append('dataset', params.dataset);
            }

            return urlWithParams
        }
    })
    .then((response) => response.data);

    return response
}

// Get data for the Heat Map in Social Dialogue - CountryOverview
export function getHeatMapData(chart, dataset)
{
    const URL = `${BASEURL}quantitative/getHeatMapData`;
    const response = axios.get(URL, {
        params: {
            chart: chart,
            dataset: dataset
        },
        paramsSerializer: params => {
            let urlWithParams = new URLSearchParams();

            if (params.chart) {
                urlWithParams.append('chart', params.chart);
            }

            if (params.dataset) {
                urlWithParams.append('dataset', params.dataset);
            }

            return urlWithParams
        }
    })
    .then((response) => response.data);

    return response
}

//Get countries available for health perception select
export function getHealthPerceptionCountries() {
    const URL = `${BASEURL}countries/getIndicatorCountries?chart=20026`;

    const response = axios.get(URL)
    .then((res) => res.data);

    return response
}

//Get health perception data for each available country including EU27
export function getHealthPerceptionData(filters){
    const URL = `${BASEURL}quantitative/getCountryCardData?chart=20026`;
    const response = axios.get(URL, {
        params: {
            country: filters?.countries,
            datasetEurofound: filters?.datasetEurofound,
            datasetEurostat: filters?.datasetEurostat
        },
        
        paramsSerializer: params => {
            let urlWithParams = new URLSearchParams();

            if (params.country) {
                params.country.map((country) => urlWithParams.append('country', country.code));
            }

            if (params.datasetEurofound)
            {
                urlWithParams.append('datasetIndicator1', params.datasetEurofound);
            }

            if (params.datasetEurostat)
            {
                urlWithParams.append('datasetIndicator2', params.datasetEurostat);
            }

            return urlWithParams
        }
    })  
    .then((response) => response.data);
    
    return response
}

export function getCountryDataMap(datasetIndicator1, datasetIndicator2, datasetIndicator3, datasetIndicator4, country){
    const URL = `${BASEURL}quantitative/getCountryCardData?chart=20012`;
    const response = axios.get(URL,{
        params: {
            datasetIndicator1,
            datasetIndicator2,
            datasetIndicator3,
            datasetIndicator4
        },
        paramsSerializer: params => {
            let urlWithParams = new URLSearchParams()

            if (params.datasetIndicator1)
            {
                urlWithParams.append('datasetIndicator1',datasetIndicator1)
            }

            if (params.datasetIndicator2)
            {
                urlWithParams.append('datasetIndicator2',datasetIndicator2)
            }

            if (params.datasetIndicator3)
            {
                urlWithParams.append('datasetIndicator3',datasetIndicator3)
            }

            if (params.datasetIndicator4)
            {
                urlWithParams.append('datasetIndicator4',datasetIndicator4)
            }

            return urlWithParams;
        }
    }).then((res) => res.data)

    return response
}

export function getChartDataRisk(chart, indicator, country1, country2, country3, sector, gender, age, skill, answer, dataset){
    const URL = `${BASEURL}quantitative/getChartData`;
    //?&sector=9&sector=10&sector=11&sector=12&sector=13&sector=8
  
    const response = axios.get(URL, {
        params: {
            chart,
            indicator,
            country1,
            country2,
            country3, 
            sector,
            gender,
            age,
            skill,
            answer, 
            dataset
        },
        paramsSerializer: params =>{
            let urlWithParams = new URLSearchParams()

            if(params.chart){
                urlWithParams.append('chart',chart)
            }

            if(params.indicator){
                urlWithParams.append('indicator',indicator)
            }

            if (params.country1){
                urlWithParams.append('country1',country1)
            }

            if(params.country2){
                urlWithParams.append('country2',country2)
            }
            if(params.country3){
                urlWithParams.append('country3',country3)
            }
            if(params.sector){
                params.sector.map(element => urlWithParams.append('sector',element))
            }

            if (params.gender){
                params.gender.map(element => urlWithParams.append('gender',element))
            }

            if (params.age){
                params.age.map(element => urlWithParams.append('age',element))
            }

            if (params.skill){
                params.skill.map(element => urlWithParams.append('skill',element))
            }

            if (params.answer){
                params.answer.map(element => urlWithParams.append('answer',element))
            }

            if (params.dataset){
                urlWithParams.append('dataset',dataset)
            }

            return urlWithParams;
        }
    }).then((res)=> {
        return res.data
    })

    return response;
}

// Get the datasource and the dates for the credits of the chart
export function getDatasourceAndDates (chart, dataset)
{
    const URL = `${BASEURL}metadata/getChartMetadata`;
  
    const response = axios.get(URL, {
        params: {
            chart,
            dataset            
        },
        paramsSerializer: params =>{
            let urlWithParams = new URLSearchParams()

            if(params.chart){
                urlWithParams.append('chart',chart)
            }

            if(params.dataset){
                urlWithParams.append('dataset',dataset)
            }

            return urlWithParams;
        }
    }).then((res)=> {
        let text = '';
        for (let i = 0; i < res.data.resultset.length; i++)
        {
            if (i > 0)
            {
                text = text + '; ';
            }
            let metadata = res.data.resultset[i];
            text = text + metadata.source + ', ' + metadata.yearFrom;
            if (metadata.yearTo != null)
            {
                text = text + '-' + metadata.yearTo;
            }
        }
        return text;
    })

    return response;
}

// Get Spider Chart for Physical-Risk
export function getSpiderChart(chart, country1, country2, country3, dataset){
    const URL = `${BASEURL}quantitative/getRadarChartData`

    const response = axios.get(URL,{
        params:{
            chart,
            country1,
            country2,
            country3,
            dataset
        },
        paramsSerializer: params => {
            let urlWithParams = new URLSearchParams();

            if (params.chart) {
                urlWithParams.append('chart', params.chart);
            }
            if (params.country1){
                urlWithParams.append('country1', params.country1)
            }
            if (params.country2){
                urlWithParams.append('country2', params.country2)
            }
            if ( params.country3){
                urlWithParams.append('country3', params.country3)
            }
            if (params.dataset){
                urlWithParams.append('dataset', params.dataset)
            }
            return urlWithParams
        }
        
    }).then((res)=>{
        return res.data
    })

    return response;
}

// Get Indicators for a section in the methodology page
export function getMethodologyIndicators (section)
{
    const URL = `${BASEURL}metadata/getMethodologyIndicators`

    const response = axios.get(URL,{
        params:{
            section
        },
        paramsSerializer: params => {
            let urlWithParams = new URLSearchParams();

            if (params.section)
            {
                urlWithParams.append('section', params.section);
            }
            return urlWithParams
        }
    }).then((res)=>{
        return res.data
    })

    return response;
}

// Get the methodology data for all the indicators for one section or for one indicator
export function getMethodologyData (section, indicator)
{
    const URL = `${BASEURL}metadata/getMethodologyData`

    const response = axios.get(URL,{
        params:{
            section,
            indicator
        },
        paramsSerializer: params => {
            let urlWithParams = new URLSearchParams();

            if (params.section)
            {
                urlWithParams.append('section', params.section);
            }
            if (params.indicator)
            {
                urlWithParams.append('indicator', params.indicator);
            }
            return urlWithParams
        }
    }).then((res)=>{
        return res.data
    })

    return response;
}

// get data for the tables in the Fullt Country Report
export function getTableData(chart, split, country, sector, answers, size, skill, illness) {
    const URL = `${BASEURL}quantitative/getTableData`

    const response = axios.get(URL, {
        params: {
            chart,
            split,
            country,
            sector,
            answers,
            size,
            skill,
            illness
        },
        paramsSerializer: params => {
            let urlWithParams = new URLSearchParams();

            if (params.chart) {
                urlWithParams.append('chart', params.chart);
            }

            if (params.split) {
                urlWithParams.append('split', params.split);
            }

            if (params.country) {
                urlWithParams.append('country', params.country);
            }

            if (params.sector) {
                params.sector.map((sector) => urlWithParams.append('sector', sector)); 
            }

            if (params.answers) {
                params.answers.map((answer) => urlWithParams.append('answer', answer));
            }

            if (params.size) {
                params.size.map((size) => urlWithParams.append('size', size));
            }

            if (params.skill) {
                params.skill.map((skill) => urlWithParams.append('skill', skill));
            }

            if (params.illness) {
                urlWithParams.append('illness', illness);
            }

            return urlWithParams
        }
    }).then((res) => {
        return res.data
    })

    return response;
}

export function getExistingDatasets(chart, indicator, isEsener, dataset, yearOnly, split){
    const URL = `${BASEURL}metadata/getIndicatorDatasets`

    const response = axios.get(URL, {
        params: {
            chart,
            indicator,
            isEsener,
            dataset,
            yearOnly,
            split
        },
        paramsSerializer: params => {
            let urlWithParams = new URLSearchParams();

            if (params.chart) {
                urlWithParams.append('chart', params.chart);
            }

            if (params.indicator) {
                if (typeof indicator === 'string')
                {
                    // Only one indicator received, only one indicator in the chart
                    urlWithParams.append('indicator', params.indicator);    
                }
                else
                {
                    // More than one indicator received, add all the indicators to the URL
                    indicator.map(( indicatorId ) => urlWithParams.append('indicator', indicatorId));
                }
            }

            if (params.isEsener) {
                urlWithParams.append('esener', params.isEsener);
            }

            if (params.dataset) {
                urlWithParams.append('dataset', params.dataset);
            }

            if (params.yearOnly) {
                urlWithParams.append('divide', params.yearOnly);
            }

            if (params.split) {
                urlWithParams.append('split', params.split)
            }

            return urlWithParams
        }
    }).then((res) => {
        return res.data
    })

    return response;

}

export function getNewChartData(filter){
    const URL = `${BASEURL}quantitative/getNewChartData`

    const response = axios.get(URL, {
        params: {
            chart: filter.chart,
            indicator: filter.indicator,
            country1: filter.country1,
            country2: filter.country2,
            country3: filter.country3,
            answer: filter.answer, 
            illness: filter.illness,
            datasetIndicator1: filter.datasetIndicator1, 
            datasetIndicator2: filter.datasetIndicator2,
            sector: filter.sector,
            age: filter.age,
            occupation: filter.occupation,
            selectedCountry: filter.selectedCountry,
            indicator2: filter.indicator2,
            size: filter.size,
            sector1: filter.sector1,
            sector2: filter.sector2,
            sector3: filter.sector3,
            answer1: filter.answer1,
            answer2: filter.answer2,
            answer3: filter.answer3,
        },
        paramsSerializer: params => {
            let urlWithParams = new URLSearchParams();

            if (params.chart) {
                urlWithParams.append('chart', params.chart);
            }

            if (params.indicator) {
                if (typeof params.indicator === 'string')
                {
                    // Only one indicator received, only one indicator in the chart
                    urlWithParams.append('indicator', params.indicator);    
                }
                else
                {
                    // More than one indicator received, add all the indicators to the URL
                    params.indicator.map(( indicatorId ) => urlWithParams.append('indicator', indicatorId));
                }
            }

            if (params.country1) {
                urlWithParams.append('country1', params.country1);
            }

            if (params.country2) {
                urlWithParams.append('country2', params.country2);
            }

            if (params.country3) {
                urlWithParams.append('country3', params.country3);
            }

            if (params.answer) {
                if (typeof params.answer === 'string')
                {
                    // Only one answer received, only one illness in the chart
                    urlWithParams.append('answer', params.answer);    
                }
                else
                {
                    // More than one answer received, add all the indicators to the URL
                    params.answer.map(( answerId ) => urlWithParams.append('answer', answerId));
                }
            }

            if (params.illness) {
                if (typeof params.illness === 'string')
                {
                    // Only one illness received, only one illness in the chart
                    urlWithParams.append('illness', params.illness);    
                }
                else
                {
                    // More than one indicator received, add all the indicators to the URL
                    params.illness.map(( illnessId ) => urlWithParams.append('illness', illnessId));
                }
            }

            if (params.datasetIndicator1 && params.datasetIndicator2) {
                urlWithParams.append('datasetIndicator1', params.datasetIndicator1);
                urlWithParams.append('datasetIndicator2', params.datasetIndicator2);
            }

            if (params.datasetIndicator1 && !params.datasetIndicator2) {
                urlWithParams.append('dataset', params.datasetIndicator1);
            }

            if (params.sector) {
                if (typeof(sector) === 'string')
                {
                    urlWithParams.append('sector', params.sector);
                }
                else
                {
                    params.sector.map(( sectorId ) => urlWithParams.append('sector', sectorId));
                }
            }

            if (params.age) {
                params.age.map(( ageId ) => urlWithParams.append('age', ageId));
            }

            if (params.occupation) {
                params.occupation.map(( occupationId ) => urlWithParams.append('occupation', occupationId));
            }

            if (params.selectedCountry) {
                urlWithParams.append('selectedCountry', params.selectedCountry);
            }

            if (params.indicator2) {
                urlWithParams.append('indicator2', params.indicator2);
            }

            if (params.size) {
                params.size.map(( sizeId ) => urlWithParams.append('size', sizeId));
            }

            if (params.sector1) {
                urlWithParams.append('sector1', params.sector1);
            }

            if (params.sector2) {
                urlWithParams.append('sector2', params.sector2);
            }

            if (params.sector3) {
                urlWithParams.append('sector3', params.sector3);
            }

            if (params.answer1) {
                urlWithParams.append('answer1', params.answer1);
            }

            if (params.answer2) {
                urlWithParams.append('answer2', params.answer2);
            }

            if (params.answer3) {
                urlWithParams.append('answer3', params.answer3);
            }

            return urlWithParams
        }
    }).then((res) => {
        return res.data
    })

    return response;

}

export function getTotalValue(chart, indicator, country1)
{
    const URL = `${BASEURL}quantitative/getTotalValueData`

    const response = axios.get(URL, {
        params: {
            chart,
            indicator,
            country1
        },
        paramsSerializer: params => {
            let urlWithParams = new URLSearchParams();

            if (params.chart) {
                urlWithParams.append('chart', params.chart);
            }

            if (params.indicator) {
                if (typeof indicator === 'string')
                {
                    // Only one indicator received, only one indicator in the chart
                    urlWithParams.append('indicator', params.indicator);    
                }
                else
                {
                    // More than one indicator received, add all the indicators to the URL
                    indicator.map(( indicatorId ) => urlWithParams.append('indicator', indicatorId));
                }
            }

            if (params.country1) {
                urlWithParams.append('country1', params.country1);
            }

            return urlWithParams
        }
    }).then((res) => {
        return res.data
    })

    return response;
}

export function getChartAnswers(chart, indicator, dataset){
    const URL = `${BASEURL}filters/getChartAnswers`
    const response = axios.get(URL, {
        params: {
            chart,
            indicator,
            dataset
        },
        
        paramsSerializer: params => {
            let urlWithParams = new URLSearchParams();
            if (params.chart) {
                if (typeof params.chart === 'string')
                {
                    // Only one chart received, only one chart in the chart
                    urlWithParams.append('chart', params.chart);    
                }
                else
                {
                    // More than one chart received, add all the charts to the URL
                    params.chart.map(( chartId ) => urlWithParams.append('chart', chartId));
                }
            }

            if (params.indicator) {
                if (typeof params.indicator === 'string')
                {
                    // Only one indicator received, only one indicator in the chart
                    urlWithParams.append('indicator', params.indicator);    
                }
                else
                {
                    // More than one indicator received, add all the indicators to the URL
                    params.indicator.map(( indicatorId ) => urlWithParams.append('indicator', indicatorId));
                }
            }

            if (params.dataset) {
                if (typeof params.dataset === 'string')
                {
                    // Only one dataset received, only one dataset in the chart
                    urlWithParams.append('dataset', params.dataset);    
                }
                else
                {
                    // More than one dataset received, add all the datasets to the URL
                    params.dataset.map(( datasetId ) => urlWithParams.append('dataset', datasetId));
                }
            }
            console.log(urlWithParams);
            return urlWithParams
        }
    }).then((res) => {
        return res.data
    })

    return response;
}

//Get countries available for health perception select
export function getDiseasesGroupsCountries(chart) {
    const URL = `${BASEURL}countries/getIndicatorCountries`;

    const response = axios.get(URL, {
        params: {
            chart
        },
        paramsSerializer: params => {
            let urlWithParams = new URLSearchParams();

            if (params.chart) {
                urlWithParams.append('chart', params.chart);
            }

            return urlWithParams
        }
    }).then((res) => {
        return res.data
    })

    return response;
}

// Get data for the table to be shown instead of the map
export function getMapTableData(chart)
{
    const URL = `${BASEURL}quantitative/getMapTableData`;

    const response = axios.get(URL, {
        params: {
            chart
        },
        paramsSerializer: params => {
            let urlWithParams = new URLSearchParams();

            if (params.chart) {
                urlWithParams.append('chart', params.chart);
            }

            return urlWithParams
        }
    }).then((res) => {
        return res.data
    })

    return response;
}

// Get data for the chart map
export function getMapData(chart, indicator)
{
    const URL = `${BASEURL}quantitative/getMapData`;

    const response = axios.get(URL, {
        params: {
            chart,
            indicator
        },
        paramsSerializer: params => {
            let urlWithParams = new URLSearchParams();

            if (params.chart) {
                urlWithParams.append('chart', params.chart);
            }

            if (params.indicator) {
                urlWithParams.append('indicator', params.indicator);
            }

            return urlWithParams
        }
    }).then((res) => {
        return res.data
    })

    return response;
}